// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as TestUtils$OrcaPaymentPage from "./Utilities/TestUtils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./Utilities/JotaiAtoms.bs.js";
import * as ConfirmType$OrcaPaymentPage from "./Types/ConfirmType.bs.js";
import * as PaymentBody$OrcaPaymentPage from "./Utilities/PaymentBody.bs.js";
import * as VaultHelpers$OrcaPaymentPage from "./Payments/VaultHelpers.bs.js";
import * as CardThemeType$OrcaPaymentPage from "./Types/CardThemeType.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "./Utilities/PaymentHelpers.bs.js";
import * as PaymentHelpersV2$OrcaPaymentPage from "./Utilities/PaymentHelpersV2.bs.js";
import * as PaymentInputField$OrcaPaymentPage from "./Components/PaymentInputField.bs.js";
import * as PaymentManagementBody$OrcaPaymentPage from "./Utilities/PaymentManagementBody.bs.js";
import * as SubscriptionEventHooks$OrcaPaymentPage from "./Hooks/SubscriptionEventHooks.bs.js";

function CardCVCElement(props) {
  var __isVaultCvcFlow = props.isVaultCvcFlow;
  var paymentType = props.paymentType;
  var cvcProps = props.cvcProps;
  var isVaultCvcFlow = __isVaultCvcFlow !== undefined ? __isVaultCvcFlow : false;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var emitter = SubscriptionEventHooks$OrcaPaymentPage.useSubscriptionEventEmitter();
  var match$1 = match.config.appearance;
  var keys = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  var customPodUri = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.customPodUri);
  var loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  var redirectionFlags = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  var vaultCredentials = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.vaultCredentials);
  var setCvcError = cvcProps.setCvcError;
  var cvcError = cvcProps.cvcError;
  var cvcNumber = cvcProps.cvcNumber;
  var isCvcEmpty = cvcNumber === "";
  var isCvcComplete = cvcNumber.length >= 3;
  var compressedLayoutStyleForCvcError = match$1.innerLayout === "Compressed" && cvcError.length > 0 ? "!border-l-0" : "";
  var submitCallback = React.useCallback((function (ev) {
          if (isVaultCvcFlow) {
            var confirmDict = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.safeParse(ev.data));
            var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(confirmDict);
            var isOuterValid = Utils$OrcaPaymentPage.getBool(confirmDict, "isOuterValid", true);
            if (!confirm.doSubmit) {
              return ;
            }
            Utils$OrcaPaymentPage.getString(confirmDict, "paymentToken", "");
            var match;
            if (typeof vaultCredentials !== "object" || vaultCredentials.TAG !== "HyperswitchVault") {
              match = [
                "",
                ""
              ];
            } else {
              var creds = vaultCredentials._0;
              match = [
                creds.pmSessionId,
                creds.sdkAuthorization
              ];
            }
            var isCvcComplete = cvcNumber.length >= 3;
            if (isCvcComplete && isOuterValid) {
              setCvcError(function (param) {
                    return "";
                  });
              Core__Promise.$$catch(PaymentHelpersV2$OrcaPaymentPage.updatePaymentMethod(PaymentManagementBody$OrcaPaymentPage.vaultUpdateCVVBody(cvcNumber), match[0], loggerState, customPodUri, match[1]).then(function (res) {
                        var vaultTokenData = VaultHelpers$OrcaPaymentPage.decodeVaultTokenData(res);
                        if (vaultTokenData.token !== "") {
                          Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                                [
                                  "savedCardCvcTokenEvent",
                                  true
                                ],
                                [
                                  "cvcToken",
                                  vaultTokenData.token
                                ]
                              ]);
                        } else {
                          Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
                        }
                        return Promise.resolve();
                      }), (function (param) {
                      Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
                      return Promise.resolve();
                    }));
              return ;
            }
            if (!isOuterValid) {
              return ;
            }
            var errorMsg = cvcNumber.length === 0 ? localeString.cvcNumberEmptyText : localeString.inCompleteCVCErrorText;
            setCvcError(function (param) {
                  return errorMsg;
                });
            return Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", errorMsg);
          }
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          try {
            var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
            var confirmParams = dict["requestCVCConfirm"];
            if (confirmParams === undefined) {
              return ;
            }
            var confirmParamsDict = Utils$OrcaPaymentPage.getDictFromJson(confirmParams);
            var requiresCvv = Utils$OrcaPaymentPage.getBool(confirmParamsDict, "requiresCvv", true);
            if (paymentType !== "CardCVCElement") {
              return ;
            }
            var body = Utils$OrcaPaymentPage.getJsonObjectFromDict(confirmParamsDict, "body");
            var bodyArr = Object.entries(Core__Option.getOr(Core__JSON.Decode.object(body), {}));
            var payload = Utils$OrcaPaymentPage.getJsonFromDict(confirmParamsDict, "payload", null);
            var paymentTypeStr = Utils$OrcaPaymentPage.getString(confirmParamsDict, "paymentType", "card");
            var publishableKeyVal = Utils$OrcaPaymentPage.getString(confirmParamsDict, "publishableKey", keys.publishableKey);
            var clientSecretVal = Utils$OrcaPaymentPage.getString(confirmParamsDict, "clientSecret", Core__Option.getOr(keys.clientSecret, ""));
            var isCvcComplete$1 = cvcNumber.length >= 3;
            if (requiresCvv && isCvcComplete$1) {
              setCvcError(function (param) {
                    return "";
                  });
              var bodyWithCvc = bodyArr.concat([PaymentBody$OrcaPaymentPage.cardTokenCvcTuple(cvcNumber)]);
              var paymentType$1 = PaymentHelpers$OrcaPaymentPage.getPaymentType(paymentTypeStr);
              Core__Promise.$$catch(PaymentHelpers$OrcaPaymentPage.paymentIntentForPaymentSession(bodyWithCvc, paymentType$1, payload, publishableKeyVal, clientSecretVal, loggerState, customPodUri, redirectionFlags, undefined, Caml_option.some(keys.sdkAuthorization), "CardCVCElement").then(function (response) {
                        Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                                "cvcWidgetConfirmResponse",
                                response
                              ]]);
                        return Promise.resolve();
                      }), (function (err) {
                      Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                              "cvcWidgetConfirmErrorResponse",
                              JSON.stringify(Utils$OrcaPaymentPage.formatException(err))
                            ]]);
                      return Promise.resolve();
                    }));
              return ;
            }
            if (!requiresCvv) {
              return Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                            "cvcWidgetConfirmErrorResponse",
                            Utils$OrcaPaymentPage.handleFailureResponse("Something went wrong", "cvc_validation_failed")
                          ]]);
            }
            var isEmptyCVC = cvcNumber.length === 0;
            var errorMsg$1 = isEmptyCVC ? localeString.cvcNumberEmptyText : localeString.inCompleteCVCErrorText;
            setCvcError(function (param) {
                  return errorMsg$1;
                });
            return Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                          "cvcWidgetConfirmErrorResponse",
                          Utils$OrcaPaymentPage.handleFailureResponse(errorMsg$1, "cvc_validation_failed")
                        ]]);
          }
          catch (exn){
            return Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                          "cvcWidgetConfirmErrorResponse",
                          Utils$OrcaPaymentPage.handleFailureResponse("Something went wrong", "cvc_validation_failed")
                        ]]);
          }
        }), [
        isVaultCvcFlow,
        cvcNumber,
        keys,
        paymentType,
        loggerState,
        customPodUri,
        redirectionFlags,
        localeString,
        vaultCredentials
      ]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  React.useEffect((function () {
          SubscriptionEventHooks$OrcaPaymentPage.emitReady(keys.iframeId, CardThemeType$OrcaPaymentPage.getPaymentModeToString(paymentType));
        }), [
        keys.iframeId,
        paymentType
      ]);
  React.useEffect((function () {
          if (!isVaultCvcFlow) {
            var cvcInfoDict = Object.fromEntries([[
                    "isCvcEmpty",
                    isCvcEmpty
                  ]]);
            Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                    "cvcInfo",
                    cvcInfoDict
                  ]]);
          }
          
        }), [isCvcEmpty]);
  React.useEffect((function () {
          emitter.emitCvcStatus(keys.iframeId, isCvcEmpty, isCvcComplete);
        }), [
        isCvcEmpty,
        isCvcComplete,
        keys.iframeId
      ]);
  return React.createElement(PaymentInputField$OrcaPaymentPage.make, {
              isValid: Caml_option.some(cvcProps.isCVCValid),
              setIsValid: cvcProps.setIsCVCValid,
              height: isVaultCvcFlow ? "1.8rem" : "",
              value: cvcNumber,
              onChange: cvcProps.changeCVCNumber,
              onBlur: cvcProps.handleCVCBlur,
              errorString: cvcError,
              fieldName: isVaultCvcFlow ? "" : localeString.cvcTextLabel,
              name: TestUtils$OrcaPaymentPage.cardCVVInputTestId,
              type_: "tel",
              maxLength: 4,
              placeholder: "123",
              className: "tracking-widest w-full " + compressedLayoutStyleForCvcError,
              inputRef: cvcProps.cvcRef,
              autocomplete: "cc-csc"
            });
}

var make = CardCVCElement;

export {
  make ,
}
/* jotai Not a pure module */
